export interface ToolPhase {
  label: string;
  targetProgress: number;
  duration: number;
}

export interface ToolAnimationConfig {
  phases: ToolPhase[];
}

export const TOOL_ANIMATIONS: Record<string, ToolAnimationConfig> = {
  retrieve_candidate_with_requirements: {
    phases: [
      {
        label: "Analyzing requirements...",
        targetProgress: 10,
        duration: 8000,
      },
      { label: "Finding candidates...", targetProgress: 45, duration: 30000 },
      {
        label: "Evaluating candidates...",
        targetProgress: 75,
        duration: 35000,
      },
      { label: "Scoring candidates...", targetProgress: 90, duration: 25000 },
      { label: "Preparing results...", targetProgress: 95, duration: 12000 },
    ],
  },
  create_job_description: {
    phases: [
      {
        label: "Analyzing requirements...",
        targetProgress: 30,
        duration: 3000,
      },
      {
        label: "Writing job description...",
        targetProgress: 70,
        duration: 5000,
      },
      { label: "Finalizing...", targetProgress: 95, duration: 4000 },
    ],
  },
  search_linkedin_profiles: {
    phases: [
      { label: "Preparing search...", targetProgress: 25, duration: 2000 },
      { label: "Searching LinkedIn...", targetProgress: 70, duration: 8000 },
      { label: "Processing profiles...", targetProgress: 95, duration: 5000 },
    ],
  },
  upload_content_to_s3: {
    phases: [
      { label: "Uploading document...", targetProgress: 60, duration: 2000 },
      { label: "Saving...", targetProgress: 95, duration: 2000 },
    ],
  },
};

export const FALLBACK_ANIMATION: ToolAnimationConfig = {
  phases: [
    { label: "Processing...", targetProgress: 50, duration: 4000 },
    { label: "Almost done...", targetProgress: 95, duration: 6000 },
  ],
};

export function getToolAnimation(toolName: string): ToolAnimationConfig {
  return TOOL_ANIMATIONS[toolName] ?? FALLBACK_ANIMATION;
}
